<template>
  <div class="authorization">
    <el-page-header @back="$router.go(-1)" content="后台授权" style="margin-bottom: 20px;">
    </el-page-header>
    <div style="margin:30px 0;">
    当前职位：<label style="font-weight: bold;font-size: 24px;">{{pName}} （{{department}}） </label>
    </div>

    <el-tree
      :data="list"
      ref="tree"
      show-checkbox
      :default-expand-all="true"
      :check-strictly="true"
      :indent="64"
      node-key="id"
      :highlight-current="true"
      :default-checked-keys="checkedCities"
      @check-change="handleCheckChange"
      :props="defaultProps">
    </el-tree>
    <div class="btn">
        <el-button type="primary" @click="submit">保存</el-button>

    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
export default {
  data() {
    return {
      id: "",
      checkAll: false,
      checkedCities: [],
      cities: [],
      isIndeterminate: true,
      list:[],
      id_list:'',
      pName:"",//职位名称
      department:"",//部门
      defaultProps: {
        children: 'children',
        label: 'name'
      }
    };
  },
  activated() {

    if( typeof(this.$route.query.id) !=undefined && this.$route.query.id ) {
       this.id = this.$route.query.id;

       this.getData();
    }
    if( typeof(this.$route.query.pName) !=undefined && this.$route.query.pName ) {
       this.pName = this.$route.query.pName;
    }
    if( typeof(this.$route.query.department) !=undefined && this.$route.query.department ) {
       this.department = this.$route.query.department;
    }


  },
  methods: {
      submit(){
        this.id_list=this.checkedCities.toString()
          this.post("adminrole/addauth", {msid:this.id_list,id:this.id}).then((res) => {
              if (res.data.code == 1) {
                Message.success(res.data.msg);
                var that = this;
                setTimeout(function () {
                  that.$router.go(-1);
                }, 1000);
              } else {
                Message.error(res.data.msg);
              }
            });
      },
      handleCheckedCitiesChange(value) {
        console.log(value);
        this.checkedCities=value
    },
    getData() {
      this.gets("adminrole/getAuthInfo?id=" + this.id).then((res) => {
          this.list=res.data.data.auth_list;//所有权限

          this.checkedCities= res.data.data.auth_info;//已选权限
      });
    },
    handleCheckChange(data, checked, indeterminate) {
      this.checkedCities = this.$refs.tree.getCheckedKeys();
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/system/authorization.vue